// Set of helpers to help with conversion from API URL to environment name and vice-versa. It is only to be used
// for dev environments, to implement the environment selector.

export function getDevEnvironmentFromUrl(url: string): string | undefined {
  return url.match(/bimtrack(\w+).(co|xyz)/)?.[1];
}

export function getDevApiUrlFromEnvironment(env: string): string {
  const ext = env === 'dev' ? 'co' : 'xyz';
  return `https://api.bimtrack${env}.${ext}`;
}

export function getAuthUrlFromApiUrl(url: string): string {
  return url?.replace('api', 'auth');
}
